var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarTopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.759,
    height: 73.852,
    viewBox: "0 0 73.759 73.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_351",
    x: 0,
    y: 0,
    width: 73.759,
    height: 73.852,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351-2",
    "data-name": "Path 351",
    d: "M289.178,78.674,287.121,94.2l-13.645-7.679-15.4,2.84,3.087-15.35-7.46-13.766,15.553-1.807,10.787-11.348,6.525,14.233L300.7,68.071Z",
    transform: "matrix(0.98, 0.21, -0.21, 0.98, -219.58, -92.8)",
    fill: "#fa0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarTopIcon);
export default __webpack_public_path__ + "static/media/star_top_icon.d4d94168af0bb6152393648b9533c089.svg";
export { ForwardRef as ReactComponent };